import styles from "./ManageDevices.module.scss"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const ManageDevices = () => {

  const data = [
    { devices: 'Device name', permissions: 'Inventory Management', lastLogin: '04/07/2024' },
    { devices: 'Device name', permissions: 'Inventory Management', lastLogin: '04/07/2024' },
    { devices: 'Device name', permissions: 'Full access', lastLogin: '04/07/2024' },
    { devices: 'Device name', permissions: 'Full access', lastLogin: '04/07/2024' },
  ]

  const columns = [
    { name: 'Login devices', selector: row => row.devices },
    { name: 'Permissions', selector: row => row.permissions },
    { name: 'Last Login', selector: row => row.lastLogin },
    { name: 'Action', cell: () => <span className="cursor-pointer">Remove</span> },
  ]

  return (
    <div className="py-3">
      <div className={styles["heading"]}>Manage Devices</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <DatatableComponent columns={columns} data={data} type={'gray'} />
        </div>
      </div>
    </div>
  )
}

export default ManageDevices
